import React from 'react';
import { FDDialog } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { JustWinContainer } from 'Components/Modals/Investment/JustWinDialog/JustWinContainer';

const JustWinDialog = ({ onClose, justWinRelationship }) => {
  return (
    <FDDialog
      open
      color={'subtle'}
      dialogWidth={'sm'}
      closeOnBackdropClick={false}
      noCloseButton
    >
      <JustWinContainer relationship={justWinRelationship} onSubmit={onClose} />
    </FDDialog>
  );
};

JustWinDialog.defaultProps = {};

JustWinDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  justWinRelationship: PropTypes.object.isRequired,
};

export { JustWinDialog };
